export default {
  CONSTITUTION: 'CONSTITUTION',
  PARTNERS: 'PARTNERS',
  DIRECTORS: 'DIRECTORS',
  SOCIETY: 'SOCIETY',
  GENERIC: 'GENERIC',
  SOCIETY_PARTNERS_CONSTITUTION: 'SOCIETY_PARTNERS_CONSTITUTION',
};
